module.exports = __webpack_public_path__ + "img/EgyptTechSiegeTowerS_ua.a443698c.webp";